"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../constants");
const DatahubService_1 = __importDefault(require("../DatahubService"));
const helper_1 = require("../helper");
const event_agent_js_1 = __importDefault(require("@hotmart/event-agent-js"));
class DatahubContentImportService {
    constructor() {
        this.system = constants_1.SYSTEMS.APP_CLUB_ADMIN;
        this.entity = 'import_content';
        this.category = 'ContentImport';
        this.sendCancelEvent = (event) => {
            event_agent_js_1.default.send({
                system: this.system,
                entity: this.entity,
                action: 'cancel',
                event
            });
        };
        this.sendStartEvent = (event) => {
            event_agent_js_1.default.send({
                system: this.system,
                entity: this.entity,
                action: 'start',
                event
            });
        };
        this.sendFinishEvent = (event) => {
            event_agent_js_1.default.send({
                system: this.system,
                entity: this.entity,
                action: 'finish',
                event
            });
        };
        this.sendShowCallToActionEvent = () => {
            DatahubService_1.default.sendEvent({
                action: constants_1.EVENT_ACTIONS.INTERACT,
                event: (0, helper_1.buildInteractionEventData)({
                    category: this.category,
                    action: constants_1.EVENTS_INTERACTIONS.SHOW,
                    label: 'ShowCallToAction'
                })
            });
        };
        this.sendHelpCenterEvent = () => {
            DatahubService_1.default.sendEvent({
                action: constants_1.EVENT_ACTIONS.INTERACT,
                event: (0, helper_1.buildInteractionEventData)({
                    category: this.category,
                    action: constants_1.EVENTS_INTERACTIONS.CLICK,
                    label: 'HelpCenter'
                })
            });
        };
        this.sendCallToActionEvent = () => {
            DatahubService_1.default.sendEvent({
                action: constants_1.EVENT_ACTIONS.INTERACT,
                event: (0, helper_1.buildInteractionEventData)({
                    category: this.category,
                    action: constants_1.EVENTS_INTERACTIONS.CLICK,
                    label: 'AccessHotmartClub'
                })
            });
        };
    }
}
exports.default = new DatahubContentImportService();
